import React from 'react';
import { connect } from 'react-redux';
import objectAssign from 'object-assign';
import OrgUnitManageTagsContent from '../components/pages/org-unit/manage-tags/content';
import NotFoundPage from './NotFoundPage';
import { hasPermissionOrg } from 'businessLogic/checkExistOrVerifyPermissions';
import FeatureUnavailablePage from './FeatureUnavailablePage.js';
import { selectOrgUnitId, updateFetchingOrg } from 'actions/organisation';

@connect(mapStateToProps)
export default class OrgUnitManageTagsPage extends React.Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillMount() {
    //Set getting org = {} to force fetching org info & permission first
    this.props.dispatch(updateFetchingOrg({}));
    this.props.dispatch(selectOrgUnitId(parseInt(this.props.match.params.id)));
  }

  render() {
    // permissions check
    if (this.props.redirectToPageNotFound || !this.props.hasOrgUnits || this.props.canAccess == false) {
      if (this.props.orgUnit.name.length > 0 && !this.props.orgUnit.reportingTagsEnabled) {
        return <FeatureUnavailablePage dispatch={this.props.dispatch} />;
      } else {
        return <NotFoundPage dispatch={this.props.dispatch} />;
      }
    }

    return (
      <OrgUnitManageTagsContent
        id={parseInt(this.props.match.params.id)}
        orgUnit={this.props.orgUnit}
        searchTerm={this.props.searchTerm}
        userId={this.props.userId}
        dispatch={this.props.dispatch}
        availableTags={this.props.availableTags}
        selectedTagObject={this.props.selectedTagObject}
        showRemoveTagConfirmationModalInOU={this.props.showRemoveTagConfirmationModalInOU}
        showEditTagValueModalInOU={this.props.showEditTagValueModalInOU}
        showAssignTagsModalInOU={this.props.showAssignTagsModalInOU}
      />
    );
  }
}

function mapStateToProps(state, props) {
  let selectedOrgUnit = state.organisationsReducer.cleanOrgUnitForm;
  if (!!state.organisationsReducer.selectedOrgUnitId && state.organisationsReducer.organisations.length > 0) {
    const selectedOrgUnitId = state.organisationsReducer.selectedOrgUnitId;
    selectedOrgUnit = state.organisationsReducer.organisations.find((ou) => ou.networkId === selectedOrgUnitId);
  }

  const orgUnit = objectAssign({}, state.organisationsReducer.cleanOrgUnitForm, selectedOrgUnit);

  let availableTags = null;
  if (!!selectedOrgUnit && !!state.organisationsReducer.availableTagsByNetworkId) {
    if (state.organisationsReducer.availableTagsByNetworkId.networkId === selectedOrgUnit.networkId)
      availableTags = state.organisationsReducer.availableTagsByNetworkId.availableTags;
  }

  let canAccess = true;
  let networkId = props.match.params.id;

  if (
    state.organisationsReducer.selectedOrgUnitId &&
    state.organisationsReducer.fetchingOrganisation == false &&
    (!orgUnit.reportingTagsEnabled || !hasPermissionOrg(state, networkId, 'VIEW_ASSIGNED_TAGS'))
  ) {
    canAccess = false;
  }

  return {
    redirectToPageNotFound: state.sharedReducer.redirectToPageNotFound,
    orgUnit: orgUnit,
    searchTerm: state.organisationsReducer.currentOrgUnitTagFilter || '',
    showAssignTagsModalInOU: state.modalReducer.showAssignTagsModalInOU,
    hasOrgUnits: state.usersReducer.userProfile.hasOrganisations,
    showRemoveTagConfirmationModalInOU: state.modalReducer.showRemoveTagConfirmationModalInOU,
    showEditTagValueModalInOU: state.modalReducer.showEditTagValueModalInOU,
    availableTags: availableTags,
    userId: state.usersReducer.userProfile.id,
    selectedTagObject: state.organisationsReducer.selectedTagObject,
    canAccess,
  };
}
